export default function testProperties(hNode, description, index) {
    if (hNode?.testID != null) {
        return { 'data-testid': hNode.testID };
    }
    if (hNode?.['data-testid'] != null) {
        return { 'data-testid': hNode['data-testid'] };
    }
    const testIdParts = [description, index, hNode?.id];
    const ariaLabel = description || hNode?.['aria-label'] || hNode?.title || hNode?.alt || hNode?.label;
    return {
        'data-testid': testIdParts.filter(p => p != null).join('-'),
        'aria-label': ariaLabel
    };
}
